export enum DetailedSubsidyFilterKey {
  OrgTypes = 'orgTypesFilter',
  Orgs = 'orgFilter',
  ClassType = 'classTypeFilter',
  Parallels = 'parallelsFilter',
  SchoolYear = 'schoolYearFilter',
  EducationLevels = 'educationLevelsFilter',
  Classes = 'classesListFilter',
  Students = 'studentListFilter',
  Employees = 'employeeListFilter',
  Details = 'details',
  Group = 'detailsGroupFilter',
  Period = 'periodFilter',
  SubsidyType = 'subsidyTypeFilter',
  Allowances = 'allowancesFilter',
  SumsAndKits = 'sumsAndKitsFilter',
  ViewType = 'viewTypeFilter',
}

export enum DetailedSubsidyClassType {
  Common = 'class',
  DayCares = 'gpd',
  Camp = 'camp',
}
